"use client";

import * as React from "react";
import { Link } from "@/components/common/Link";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "@/components/ui/breadcrumb";
export default function OurTradesAndSpecialties() {
  return <section id="nuestros-oficios-y-especialidades" className="relative w-full bg-background overflow-hidden">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-foreground via-foreground/95 to-primary/90 pointer-events-none" />
      
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,var(--color-primary)_0%,transparent_40%)] opacity-20 mix-blend-screen pointer-events-none" />

      <div className="container relative z-10 mx-auto px-4 py-24 md:px-6 md:py-32 lg:py-40 flex flex-col items-start">
        
        {}
        <div className="mb-8 inline-flex items-center rounded-full bg-background/95 px-5 py-2 shadow-sm backdrop-blur-md border border-border/50">
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                <BreadcrumbLink asChild>
                  <Link to="/HomePage" className="font-medium">
                    Inicio
                  </Link>
                </BreadcrumbLink>
              </BreadcrumbItem>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                <BreadcrumbPage className="font-semibold text-primary">
                  Oferta Académica
                </BreadcrumbPage>
              </BreadcrumbItem>
            </BreadcrumbList>
          </Breadcrumb>
        </div>

        {}
        <div className="max-w-3xl">
          <h1 className="font-sans text-4xl font-bold tracking-tight text-background sm:text-5xl md:text-6xl lg:text-7xl mb-6">
            OFERTA ACADÉMICA
          </h1>
          <p className="font-sans text-lg text-background/80 md:text-xl leading-relaxed max-w-2xl">
            Catálogo completo de cursos organizados por áreas de especialización. 
            Formación práctica, actualizada y diseñada para potenciar tu desarrollo 
            profesional en todo el interior de Uruguay.
          </p>
        </div>
        
      </div>
    </section>;
}